import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const carousels = document.querySelectorAll('.news__slider.swiper');

  carousels.forEach((el) => {
    const root = el.closest('.news');

    if (!root) {
      return;
    }

    const nav = root.querySelector('.news__nav');
    const a11y = { enabled: true };

    if (nav) {
      a11y.prevSlideMessage = nav.dataset.prevLabel;
      a11y.nextSlideMessage = nav.dataset.nextLabel;
    }

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      keyboard: { enabled: true },
      a11y,
      navigation: {
        prevEl: root.querySelector('.news__prev'),
        nextEl: root.querySelector('.news__next'),
      },
      // Keep in sync with the `md` / `lg` smart-breakpoints.
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});
